import { useEffect, useState } from "react";
// import { navigate } from "gatsby";
import qs from "qs";

const getQueryParam = name => {
  if (typeof window !== "undefined") {
    const queryParams = qs.parse(window.location.search, {
      // <=> window.location = useLocation() from @reach/router
      ignoreQueryPrefix: true,
    });

    return queryParams[name];
  }

  return undefined;
};

const useQueryParam = (fieldName = "filter") => {
  const [currentValue, setCurrentValue] = useState(getQueryParam(fieldName));

  useEffect(() => {
    // Set the query param
    if (getQueryParam(fieldName) !== currentValue) {
      const uri = `${window.location.pathname}${qs.stringify(
        { [fieldName]: currentValue || null },
        { addQueryPrefix: true, skipNulls: true }
      )}`;

      window.history.replaceState({}, null, uri);
      // Better than navigate which is async and create race conditions.
      // navigate(
      //   uri,
      //   {
      //     replace: true,
      //   }
      // );
    }
  }, [fieldName, currentValue]);

  return [currentValue, setCurrentValue];
};

export default useQueryParam;